<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component shared/dias/components/custom-mini-basket-content/custom-mini-basket-content.component.ts
-->
<ng-template #anchor></ng-template>
